import ApplicationController from './application'

export default class extends ApplicationController {
  static targets = ['form']

  connect() {
    if (!this.hasFormTarget) return
    const element = this.formTarget.querySelector('.error')

    if (!element) return window.scrollTo(0, 0)
    const y = element.getBoundingClientRect().top + window.scrollY;
    window.scroll({ top: y - 100, behavior: 'smooth' })

    const tag = element.tagName.toLowerCase()
    if (['input', 'select'].includes(tag)) {
      element.focus()
    }
  }
}
